(function () {
    'use strict';

    function workflowConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/workflowConfiguration.html',
            link: function (scope) {

            }
        };
    }

    workflowConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('workflowConfiguration', workflowConfiguration);
})();
